var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FlowProvider } from "../contexts/FlowContext";
import { GraphConnectionBuilder } from "../components/GraphConnectionBuilder/GraphConnectionBuilder";
import { useEffect, useState } from "react";
import { graphController } from "../../controller/GraphController";
import { ROOT_GRAPH_ID } from "../../model/constants";
export const GraphPage = () => {
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [initialFlowState, setInitialFlowState] = useState([]);
    useEffect(() => {
        setIsDataLoading(true);
        const loadData = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield graphController.loadGraphData();
                setInitialFlowState([
                    {
                        id: ROOT_GRAPH_ID,
                        selectedFieldsByCategory: undefined,
                    },
                ]);
            }
            catch (error) {
                console.error("Failed to load graph data:", error);
            }
            finally {
                setIsDataLoading(false);
            }
        });
        loadData();
    }, []);
    return (_jsx(FlowProvider, { initialState: initialFlowState, children: _jsx(GraphConnectionBuilder, { isLoading: isDataLoading }) }));
};
